import React, { useEffect, useState } from 'react';
import { RadioGroup, Radio, FormControlLabel, Container } from '@material-ui/core'
import Loader from '../../elements/Loader';
import DataTable from '../../elements/Search/Table'

const Search = (props) => {
    const { fetchAllUsers, fetchNewUsers, isLoading, allUsers, deleteUser } = props

    const [radioValue, setRadioValue] = useState('all');

    useEffect(() => {
        if (fetchAllUsers && fetchNewUsers) {
            radioValue === 'all' ? fetchAllUsers() : fetchNewUsers();
        }
    }, [radioValue, fetchAllUsers, fetchNewUsers])


    const newData = allUsers ? allUsers.map((el, index) => {
        return { ...el, id: index + 1 }
    }) : []
    return (
        <div>
        {isLoading && <Loader />}
        <div className="text-center">
            <Container maxWidth='lg' style={{padding:'24px'}}>
            <h1>Search</h1>
            <div style={{display: 'flex', direction: 'row', justifyContent: 'center'}}>
                <RadioGroup row aria-label="search-type" name="search-type" value={radioValue} onChange={(e) => setRadioValue(e.target.value)}>
                    <FormControlLabel value="all" control={<Radio color="primary" />} labelPlacement="top" label="All users" />
                    <FormControlLabel value="new" control={<Radio color="primary" />} labelPlacement="top" label="New users" />
                </RadioGroup>
            </div>
            <DataTable allUsers={newData} deleteUser={deleteUser}/>
            </Container>
        </div>
        </div>
    )
}

export default Search